import { styled } from '@mui/material';

export const Wrapper = styled('div')(({ theme }) => ({
  position: 'sticky',
  top: 65,
  alignSelf: 'start',
  width: '100%',
  borderRadius: 8,
  // Was the hex literal `#dae2e3`, one step off the ramp and banned by DESIGN_SYSTEM.md §2.
  // grey[90] (#D6E0E2) is the neighbouring token and visually indistinguishable.
  backgroundColor: theme.palette.grey[90],
  zIndex: 20,
}));

export const Inner = styled('div')(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: '1fr 60px 120px 120px 140px 100px',
  gridGap: theme.spacing(4),
  padding: '0 16px',
}));

export const Title = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  fontWeight: 700,
  fontSize: '0.75rem',
  padding: '0.5rem 0',
  color: theme.palette.text.primary,
}));

export const Icon = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 16,
  height: 16,
  marginLeft: theme.spacing(1),
  transition: 'transform 250ms',
}));
